import React from "react";
import { Provider as SegmentProvider } from "analytics/segment";
import { LayoutProvider } from "core/components/LayoutProvider";
import { Router } from "core/components/Router";
import { Toaster } from "core/components/Toaster";
import { ValidationExceptionHeader } from "core/components/ValidationExceptionHeader";

export const Entry = () => (
  <SegmentProvider>
    <LayoutProvider>
      <ValidationExceptionHeader />
      <Router />
      <Toaster />
    </LayoutProvider>
  </SegmentProvider>
);
